import type { ConversationTurn, UUID } from '@/index'
import type { ConversationControlsState } from '../types'
import { deriveConversationControlsState } from '../utils'
import { useSubmissionState } from '../state'

interface UseConversationControlsStateReturn extends ConversationControlsState {
  readonly isSubmitting: boolean
}

export function useConversationControlsState(
  conversationId: UUID,
  sessionId: UUID,
  conversationTurn: ConversationTurn | undefined,
): UseConversationControlsStateReturn {
  const { isSubmitting } = useSubmissionState()
  const controlState = deriveConversationControlsState(conversationTurn)

  return {
    ...controlState,
    isSubmitting: isSubmitting(conversationId, sessionId),
  }
}
